import fetch from '../pubilc/fetch/fetch';

// export const domain = '//www.iduilv.com';
// export const domain = '//test.cn';

//首页
export const home = (params) =>
  // fetch.post('https://appadmin-api.jdd.com/appadmin/public/safeMobileHandler.do',{
  fetch.post(`/Api/Index/Index/`, params);

export const HotCaseMore = (params) =>
  fetch.post(`/Api/Index/HotCaseMore/`, params);

//首页加载更多
export const Index2 = (params) => fetch.post(`/Api/Index/Index2/`, params);

//首页咨询
export const homeAdvisory = (params) =>
  fetch.post(`/Api/Index/Advisory/`, params);

export const footer = (params) => fetch.post(`/Api/Index/Footer`, params);

//圈子点赞
export const like = (params) => fetch.post(`/Api/Posts/Like/`, params);

//首页-获取更多
export const getQzMore = (params) => fetch.post(`/Api/Circle/GetMore/`, params);

//案列库-首页
export const getCase = (params) => fetch.post(`/Api/Case/Index/`, params);

//案列库-详情
export const getCaseDetail = (params) =>
  fetch.post(`/Api/Case/Detail/`, params);

//案列库-列表
export const getCourseware = (params) =>
  fetch.post(`/Api/Courseware/Index/`, params);

//云课件-首页-视频
export const Common = (params) => fetch.post(`/Api/Courseware/Common/`, params);

//案列库-项目回归
export const getProjectEnd = (params) =>
  fetch.post(`/Api/ProjectEnd/Index/`, params);

//个人中心
export const userCenter = (params) => fetch.post(`/Api/User/Index/`, params);

//提交反馈
export const feedBack = (params) => fetch.post(`/Api/User/Feedback/`, params);

//删除帖子
export const deleteTz = (params) => fetch.post(`/Api/User/DeletePost/`, params);

//删除评论
export const deleteReply = (params) =>
  fetch.post(`/Api/User/DeleteReply/`, params);

// //获取图片验证码
// export const getPicVFL = (params) =>
//     fetch.post(`/Common/VerifyCode/`, params)

// //获取图片验证码
// export const checkPicVFL = (params) =>
//     fetch.post(`/Common/CheckVerify`, params)

//获取手机验证码
export const getVerifyForSms = (params) =>
  fetch.post(`/Api/Common/GetSmsVerifyCode/`, params);
// fetch.post(`/Api/Common/GetTestSmsCode/`, params);

//注册登录
export const login = (params) => fetch.post(`/Api/User/Login/`, params);

//获取登录信息
export const getUserInfo = (params) =>
  fetch.post(`/Api/User/GetUserInfo/`, params);
//保存编辑系统
export const EditCaseSystem = (params) =>
  fetch.post(`/Api/Store/EditCaseSystem/`, params);

//获取案例库首页
export const getCasesInex = (params) => fetch.post(`/Api/Case/Index/`, params);

//获取案例库详情
export const getCasesDetail = (params) =>
  fetch.post(`/Api/Case/Detail/`, params);

//获取绿建要闻首页
export const getNewsIndex = (params) => fetch.post(`/Api/News/Index/`, params);

//获取绿建要闻详情
export const getNewsDetail = (params) =>
  fetch.post(`/Api/News/Detail/`, params);

//发表绿建要闻评论
export const addReplis = (params) => fetch.post(`/Api/News/AddReplis/`, params);

export const getReplies = (params) =>
  fetch.post(`/Api/Posts/GetReplies/`, params);
//匠心记
//天气接口
export const getWeather = (params) =>
  fetch.post(`/Api/ProjectLog/GetWeather`, params);

//匠心记列表
export const getJxjList = (params) =>
  fetch.post(`/Api/ProjectLog/Index/`, params);

//匠心记详情
export const getJxjDetail = (params) =>
  fetch.post(`/Api/ProjectLog/Detail/`, params);

//匠心记项目日志
export const getJxjLog = (params) =>
  fetch.post(`/Api/ProjectLog/GetData/`, params);

//匠心记帖子详情
export const getJxjPostDetail = (params) =>
  fetch.post(`/Api/ProjectLog/PostDetail/`, params);

//匠心记签到详情
export const getJxjSignInfos = (params) =>
  fetch.post(`/Api/ProjectLog/GetSignInfos/`, params);

//匠心记发表评论
export const jxjAddReplis = (params) =>
  fetch.post(`/Api/ProjectLog/AddReplis/`, params);

//上传图片
export const uploadImage = (params) =>
  fetch.post(`/Api/Common/UploadImage/`, params, {
    isUpload: true,
    isThumb: true,
  });

//上传图片-不压缩
export const Upload = (params) =>
  fetch.post(`/Api/Common/UploadImage/`, params, { isUpload: true });

//上传图片
export const newUploadImage = (params) =>
  fetch.post(`/Api/Common/UploadImage/`, params);

//上传图片2
export const uploadImageByBlob = (params) =>
  fetch.post(`/Api/Common/UploadImageByBlob/`, params);

//上传图片3
export const uploadImageByBase = (params) =>
  fetch.post(`/Api/Common/UploadImageByBase/`, params);

//匠心记获取标签
export const getJxjTags = (params) =>
  fetch.post(`/Api/ProjectLog/GetTags/`, params);

//匠心记获取父节点列表
export const getParentProInfos = (params) =>
  fetch.post(`/Api/ProjectLog/getParentProInfos/`, params);

//匠心记获取人员类型标签
export const GetJxjProUserTypes = (params) =>
  fetch.post(`/Api/ProjectLog/GetProUserTypes/`, params);

//匠心记获取人员列表
export const GetJxjProUsers = (params) =>
  fetch.post(`/Api/ProjectLog/GetProUsers/`, params);

//匠心记申请
export const jxjAddProjectLog = (params) =>
  fetch.post(`/Api/ProjectLog/AddProjectLog/`, params);

//匠心记申请
export const jxjUpdateProjectInfo = (params) =>
  fetch.post(`/Api/ProjectLog/UpdateProjectInfo/`, params);

//添加主题
export const jxjAddPost = (params) =>
  fetch.post(`/Api/ProjectLog/AddPost/`, params);

//添加周报
export const jxjAddReport = (params) =>
  fetch.post(`/Api/ProjectLog/AddReport/`, params);

//添加QE报告
export const jxjAddQEReport = (params) =>
  fetch.post(`/Api/ProjectLog/AddQEReport/`, params);

//添加QE报告 Version2
export const jxjAddQEReportV2 = (params) =>
  fetch.post(`/Api/ProjectLog/AddQEReport2`, params, {
    headers: {
      'Content-Type': 'application/json',
    },
    //body: 'jsonData',
  });

//查看该项目是否创建QE报告
export const jxjGetProQEReport = (params) =>
  fetch.post(`/Api/ProjectLog/GetProQEReport`, params);

//添加封面
export const jxjAddCover = (params) =>
  fetch.post(`/Api/ProjectLog/AddCover/`, params);

//添加日报
export const jxjAddDaily = (params) =>
  fetch.post(`/Api/ProjectLog/AddDaily/`, params);

//-----------------行业圈--------------
//获取全部
export const getAllEnter = (params) =>
  fetch.post(`/Api/EnterPrise/GetAllEnter/`, params);

//猜你想看
export const getLikeEnter = (params) =>
  fetch.post(`/Api/EnterPrise/GetLikeEnter/`, params);

//行业圈首页
export const enterPriseIndex = (params) =>
  fetch.post(`/Api/EnterPrise/Index`, params);

//企业首页
export const enterCurrentIndex = (params) =>
  fetch.post(`/Api/EnterPrise/EnterIndex/`, params);

//企业简介
export const enterDesc = (params) =>
  fetch.post(`/Api/EnterPrise/EnterDesc/`, params);

//获取投诉列表
export const getEnterComplaint = (params) =>
  fetch.post(`/Api/EnterPrise/GetEnterComplaint/`, params);

//企业详情
export const enterDetail = (params) =>
  fetch.post(`/Api/EnterPrise/EnterDetail/`, params);

//发飙评论
export const enterAddReplis = (params) =>
  fetch.post(`/Api/EnterPrise/AddReplis/`, params);

//修改企业LOGO
export const updateEnterName = (params) =>
  fetch.post(`/Api/EnterPrise/UpdateEnterName/`, params);

//修改企业名称
export const updateEnterIcon = (params) =>
  fetch.post(`/Api/EnterPrise/UpdateEnterIcon/`, params);

//修改企业简介
export const updateEnterDesc = (params) =>
  fetch.post(`/Api/EnterPrise/UpdateEnterDesc/`, params);

//通过手机号获取用户信息
export const getUserByPhone = (params) =>
  fetch.post(`/Api/EnterPrise/GetUserByPhone/`, params);

//通过手机号获取用户信息
export const updateEnterUsers = (params) =>
  fetch.post(`/Api/EnterPrise/UpdateEnterUsers/`, params);

//课程培训
export const enterCourseIndex = (params) =>
  fetch.post(`/Api/Course/Index/`, params);

//课程培训
export const enterCourseDetail = (params) =>
  fetch.post(`/Api/Course/Details/`, params);

//-------------云智库------
//云智库首页
export const yzkIndex = (params) => fetch.post(`/Api/Yzk/Index/`, params);

//云智库详情
export const yzkDetail = (params) => fetch.post(`/Api/Yzk/Detail/`, params);

//云智库评论
export const yzkAddReplis = (params) =>
  fetch.post(`/Api/Yzk/AddReplies/`, params);

//云智库评论
export const yzkGetReplis = (params) =>
  fetch.post(`/Api/Yzk/GetReplies/`, params);

//-------------商城------
//商城首页
export const getMallIndex = (params) => fetch.post(`/Api/Store/Index/`, params);

//商品详情
export const getMallDetail = (params) =>
  fetch.post(`/Api/Store/Detail/`, params);

//行业圈--写动态
export const AddEnterPost = (params) =>
  fetch.post(`/Api/EnterPrise/AddEnterPost/`, params);

//行业圈--获取动态类型
export const GetEnterPostTypes = (params) =>
  fetch.post(`/Api/EnterPrise/GetEnterPostTypes/`, params);

//行业圈--获取今日打卡
export const GetTodaySign = (params) =>
  fetch.post(`/Api/EnterPrise/GetTodaySign/`, params);

//行业圈--获取今日打卡
export const AddEnterComplaint = (params) =>
  fetch.post(`/Api/EnterPrise/AddEnterComplaint/`, params);

//行业圈--联系购买
export const CourseOrderAdd = (params) =>
  fetch.post(`/Api/Course/CourseOrderAdd/`, params);

//----------个人中心----------
export const updateUserInfo = (params) =>
  fetch.post(`/Api/User/UpdateUserInfo/`, params);

// 匠心记--签证流--签证流首页
export const GetVisaflowInfo = (params) =>
  fetch.post(`/Api/VisaFlow/Index/`, params);

// 匠心记--签证流--创建签证流
export const CreateVisaflow = (params) =>
  fetch.post(`/Api/VisaFlow/Save/`, params);

// 匠心记--签证流--签证流详情
export const GetVisaflowDetails = (params) =>
  fetch.post(`/Api/VisaFlow/CheckFlow/`, params);

// 匠心记--签证流--修改签证流状态
export const UpdateVisaflow = (params) =>
  fetch.post(`/Api/VisaFlow/UpdateFlowStatus/`, params);

// 匠心记--协作流--获取所有协作订单
export const GetLogisticsList = (params) =>
  fetch.post(`/Api/Logistics/Coopertion/`, params);

// 匠心记--协作流--获取协作订单详情
export const GetLogisticInfo = (params) =>
  fetch.post(`/Api/Logistics/CollaborationDetail/`, params);

// 匠心记--协作流--取消订单
export const CancelLogistics = (params) =>
  fetch.post(`/Api/Logistics/CancelOrder/`, params);

// 匠心记--协作流--添加订单评论
export const AddOrderReplies = (params) =>
  fetch.post(`/Api/Logistics/Replies_OrderAdd/`, params);

// 匠心记--协作流--添加订单评论的评论
export const QuoteOrderReplies = (params) =>
  fetch.post(`/Api/Logistics/Replies_OrderQuote/`, params);

// 匠心记--协作流--获取项目信息和用户成员列表
export const GetCollaboretiveUsersInfo = (params) =>
  fetch.post(`/Api/Logistics/GetCollaboretiveUsersInfo/`, params);

// 匠心记--协作流--订单状态变更
export const UpdateOrderState = (params) =>
  fetch.post(`/Api/Logistics/StateChange/`, params);

// 匠心记--协作流--下单
export const AddCollaborativeOrder = (params) =>
  fetch.post(`/Api/Logistics/AddCollaborativeOrder/`, params);

// 匠心记--修改匠心记状态
export const SetProjectLogStatus = (params) =>
  fetch.post(`/Api/ProjectLog/SetProjectLogStatus`, params);

// 匠心记--上传竣工验收单
export const SetProjectLogJointWarranty = (params) =>
  fetch.post(`/Api/ProjectLog/SetProjectLogJointWarranty`, params);

// 匠心记--上传检测报告
export const SetProjectLogDetectionInfo = (params) =>
  fetch.post(`/Api/ProjectLog/SetProjectLogDetectionInfo`, params);

// 获取人员身份权限
export const GetProjectAuthority = (params) =>
  fetch.post(`/Api/ProjectLog/GetProjectAuthority`, params);

// 查看检测报告
export const GetProDetectionInfo = (params) =>
  fetch.post(`/Api/ProjectLog/GetProDetectionInfo`, params);

// 上传视频
export const UploadVideo = (params) =>
  fetch.post(`/BackStage/FileUpload/UploadVideo`, params, { isUpload: true });

// VUE分段上传
export const subsectionUpload = (params) =>
  fetch.post(`/Api/Common/VueUploadVideo`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

//云产品 首页
export const list = (params) => fetch.post(`/Api/Store/Index`, params);

//云产品 首页-搜索
export const SearchStore = (params) =>
  fetch.post(`/Api/Store/SearchStore`, params);

//云产品 首页-系统解决方案
export const SystemCase = (params) =>
  fetch.post(`/Api/Store/SystemCase`, params);

//云产品 详情页
export const Details = (params) => fetch.post(`/Api/Store/Details`, params);

//云产品 详情页
export const Advisory = (params) => fetch.post(`/Api/Store/Advisory`, params);

//云产品 后台详情页
export const AddStoreInfo = (params) =>
  fetch.post(`/Api/Store/AddStoreInfo`, params);

//云产品 后台详情页
export const GetTypes = (params) => fetch.post(`/Api/Store/GetTypes`, params);

//云产品 后台详情页
export const GetTags = (params) =>
  fetch.post(`/Api/ProjectLog/GetTags`, params);

//云产品 后台详情页
export const GetCasesById = (params) =>
  fetch.post(`/Api/Store/GetCasesById`, params);

//云产品 后台详情页
export const SaveStoreInfo = (params) =>
  fetch.post(`/Api/Store/SaveStoreInfo`, params);

//云产品 后台详情页
export const SaveCasesId = (params) =>
  fetch.post(`/Api/Store/SaveCasesId`, params);

//云产品 后台详情页
export const UpdateStoreInfo = (params) =>
  fetch.post(`/Api/Store/UpdateStoreInfo`, params);

//OA 智能办公系统
export const GetStoreList = (params) =>
  fetch.post(`/Api/Store/GetStoreList`, params);

//OA 智能办公系统
export const DeleteStoreInfo = (params) =>
  fetch.post(`/Api/Store/DeleteStoreInfo`, params);

//新增课件
export const caseAdd = (params) => fetch.post(`/Api/Courseware/Add`, params);

// /Api/Courseware/Play  增加播放量
export const playNum = (params) => fetch.post(`/Api/Courseware/Play`, params);

//宣传页-经销商列表
export const activityList = (params) =>
  fetch.post(`/Api/DealerSignUp/List`, params);

//宣传页-经销商报名
export const activityAdd = (params) =>
  fetch.post(`/Api/DealerSignUp/Add`, params);

//宣传页-经销商类型
export const activityTypes = (params) =>
  fetch.post(`/Api/DealerSignUp/Types`, params);

//获取工程师列表
export const GetJxjProUser = (params) =>
  fetch.post(`/Api/Noticeletter/GetProUser/`, params);

//异常列表
export const getDeviantList = (params) =>
  fetch.post(`/Api/Noticeletter/GetDeviantList`, params);

//提交信息
export const addInfo = (params) => fetch.post(`/Api/Noticeletter/Add`, params);

//提交审核
export const subConfirm = (params) =>
  fetch.post(`/Api/Noticeletter/Confirm`, params);

//获取告知函状态
export const getInfoById = (params) =>
  fetch.post(`/Api/Noticeletter/GetById`, params);

//获取小程序码
export const getCode = (params) =>
  fetch.post(`/Api/WeiXin/GetUnlimited`, params);
